// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-granth-seller-posting-off-report',
//   standalone: true,
//   imports: [],
  // templateUrl: './granth-seller-posting-off-report.component.html',
  // styleUrl: './granth-seller-posting-off-report.component.scss'
// })
// export class GranthSellerPostingOffReportComponent {

// }
import { Component, Inject } from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';

@Component({
  selector: 'app-granth-seller-posting-off-report',
  templateUrl: './granth-seller-posting-off-report.component.html',
  styleUrl: './granth-seller-posting-off-report.component.scss'
  
})

export class GranthSellerPostingOffReportComponent {

  sellerData: any[] = [];

  updateStatus: boolean = false;

  overallTotalBookCopies: number = 0;

  constructor(

    @Inject(MAT_DIALOG_DATA) public data: any,

    public dialogRef:
      MatDialogRef<GranthSellerPostingOffReportComponent>

  ) {

    // ✅ API sends a FLAT array of booking rows — group it here
    const rawData = data?.sellerData || [];

    this.sellerData = this.groupByOfficeRep(rawData);

    this.updateStatus = data.updateStatus;

    this.calculateGrandTotal();
  }

  // =========================
  // SAFE TEXT DISPLAY
  // Handles null, empty string, and the "Array" string bug
  // =========================
  safeText(value: any, fallback: string = '-'): string {

    if (value === null || value === undefined) return fallback;

    const str = String(value).trim();

    if (!str || str === 'Array') return fallback;

    return str;
  }

  // =========================
  // GROUP FLAT ROWS BY office_rep_name
  // =========================
  groupByOfficeRep(data: any[]) {

    const map = new Map<string, any>();

    data.forEach(item => {

      const rawKey = (item.office_rep_name ?? '').toString().trim();
      const key = rawKey ? rawKey : 'कार्यालय नसलेले';

      if (!map.has(key)) {

        map.set(key, {
          office_rep_name: key,
          data: [],
          group_total_book_copies: 0
        });
      }

      const group = map.get(key);

      group.data.push(item);

      group.group_total_book_copies += Number(item.total_book_copies || 0);
    });

    return Array.from(map.values());
  }

  calculateGrandTotal() {

    this.overallTotalBookCopies = 0;

    this.sellerData.forEach((office: any) => {

      this.overallTotalBookCopies += office.group_total_book_copies;

    });
  }

  getGrandTotalRecords(): number {

    let total = 0;

    this.sellerData.forEach((office: any) => {

      total += office.data.length;

    });

    return total;
  }

  // PRINT
printPageA4(): void {
  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  const printWindow = window.open('', '', 'width=1200,height=800');
  if (!printWindow) return;

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>.</title>
        <style>
          * {
            box-sizing: border-box;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          @page {
            size: A4 landscape;
            margin: 10mm;
          }

          body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
            font-size: 12px;
            color: #000;
            width: 100%;
          }

          /* HEADER TABLES */
          .header-table {
            width: 100%;
            border-collapse: collapse;
            table-layout: auto; /* Important for proper header sizing */
            margin-bottom: 5px;
          }

          .header-table th {
            padding: 6px 8px;
            text-align: center;
            font-size: 16px;
            font-weight: bold;
            border: 1px solid black;
          }

          .sub-header-table {
            width: 100%;
            border-collapse: collapse;
            table-layout: auto;
            margin-bottom: 10px;
          }

          .sub-header-table th {
            padding: 6px 8px;
            text-align: center;
            font-size: 14px;
            font-weight: bold;
            border: 1px solid black;
          }

          /* DATA TABLE */
          table.data-table {
            width: 98%;
            margin: 0 auto;
            border-collapse: collapse;
            border: 1px solid #000;
            table-layout: fixed;
          }

          th, td {
            border: 1px solid #000;
            padding: 4px 5px;
            white-space: normal;
            word-break: break-word;
            overflow-wrap: break-word;
            vertical-align: middle;
          }

          /* ALIGNMENTS */
          .text-left { text-align: left !important; }
          .text-right { text-align: right !important; }

          td.amount, th.amount { text-align: right !important; }

          /* COLUMN WIDTHS */
          th.invoice-date, td.invoice-date { width: 90px; text-align: center; }
          th.invoice-no, td.invoice-no { width: 90px; text-align: center; }
          th.book-seller, td.book-seller { width: 250px; text-align: left; }
          th.invoice-amount, td.invoice-amount,
          th.invoice-rec, td.invoice-rec,
          th.invoice-commission, td.invoice-commission,
          th.paid-commission, td.paid-commission { width: 100px; text-align: right; }
          th.commission-date, td.commission-date { width: 120px; text-align: center; white-space: normal; }

          thead { display: table-header-group; }
          tr { page-break-inside: avoid; }

          @media print {
            body { zoom: 1; }
            .noPrint { display: none !important; }
          }

        </style>
      </head>
      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();

  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 600);
}

  // EXPORT CSV
 exportExcel(fileName: string): void {

  let csvContent = '\uFEFF'; // UTF-8 BOM for Excel

  // Report Title
  csvContent += 'Office Representative Report\n\n';

  // Column Headers
  csvContent +=
    'Sr No,Seller,Taluka,District,Representative,Copies,Mobile,Distributive Mode\n';

  this.sellerData.forEach((office: any) => {

    // Office Header
    csvContent += `\nOffice Representative : ${this.safeText(office.office_rep_name)}\n`;

    office.data.forEach((row: any, index: number) => {

      csvContent +=
        `"${index + 1}",` +
        `"${this.safeText(row.name)}",` +
        `"${this.safeText(row.taluka)}",` +
        `"${this.safeText(row.district)}",` +
        `"${this.safeText(row.rep_name)}",` +
        `"${row.total_book_copies ?? 0}",` +
        `"${this.safeText(row.mobile_no)}",` +
        `"${this.safeText(row.dis_mode)}"\n`;

    });

    // Group Total
    csvContent +=
      `"","","","","Group Total","${office.group_total_book_copies}","Records","${office.data.length}"\n`;

  });

  // Grand Total
  csvContent +=
    `\n"","","","","Grand Total","${this.overallTotalBookCopies}","Records","${this.getGrandTotalRecords()}"\n`;

  const blob = new Blob(
    [csvContent],
    { type: 'text/csv;charset=utf-8;' }
  );

  const link = document.createElement('a');

  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);

  link.setAttribute(
    'download',
    `${fileName}_${new Date().toISOString().slice(0, 10)}.csv`
  );

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}

}